import type { CityConfig } from "../city-template/types";

export const hudsonConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  vitalRecordsLinks: [
    { label: "Birth & Death Certificates — NH Dept of State Vital Records", href: "https://sos.nh.gov/vital-records/", description: "Official New Hampshire vital records office in Concord" },
    { label: "Marriage Licenses — Hillsborough County Clerk", href: "https://www.hillsboroughcountynh.org/", description: "Hillsborough County Clerk — marriage license issuance" },
    { label: "Divorce Records — Hillsborough County Superior Court", href: "https://www.courts.nh.gov/", description: "Hillsborough County Superior Court — divorce decree records" },
    { label: "VitalChek — Order Vital Records Online", href: "https://www.vitalchek.com/", description: "Official partner of NH SOS for online vital record orders" },
  ],
  city: "Hudson",
  state: "New Hampshire",
  stateAbbr: "NH",
  slug: "hudson",
  route: "/cities/hudson",
  title: "Emergency Passport Hudson, NH | Fast Expedited Passport Renewal & Same-Day",
  metaDescription: "Emergency passport and expedited passport services in Hudson, NH — as fast as 24 hours. Fast passport renewal, same-day help, and child passport expediting for Hillsborough County. A+ BBB rated, registered State Dept. courier. Serving Nashua, Litchfield, Pelham.",
  h1: "Emergency & Expedited Passport Services in Hudson, NH",
  heroSubtitle: "Passport expired before your trip? Need an emergency passport fast? We help Hudson and southern New Hampshire travelers get their expedited passports as quickly as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Hudson%20New%20Hampshire%20scenic%20view%20with%20Merrimack%20River%20and%20suburban%20neighborhoods%20along%20the%20Massachusetts%20border%2C%20green%20rolling%20hills%20and%20New%20England%20landscape%2C%20warm%20summer%20light%20with%20lush%20trees%2C%20quiet%20residential%20community%20near%20Nashua%2C%20clean%20and%20inviting%20townscape%2C%20professional%20landscape%20photography%2C%20wide%20panoramic%20view%2C%20no%20visible%20text%20or%20people%2C%20soft%20earth%20tones%20and%20warm%20sky%2C%20photorealistic%20suburban%20scenery&width=1800&height=700&seq=hudson-nh-hero-001&orientation=landscape",
  heroImageAlt: "Hudson New Hampshire scenic view with Merrimack River and suburban neighborhoods along the Massachusetts border",
  geoPosition: "42.7647;-71.4398",
  geoPlacename: "Hudson, New Hampshire",
  regionalAgency: {
    name: "Boston Passport Agency",
    address: "10 Causeway St Suite 247, Boston, MA 02222",
    distance: "Located in downtown Boston — approximately 50–65 minutes from Hudson via Route 3 and I-93",
  },
  nearbyCitiesZips: [
    { name: "Hudson", zips: "03051" },
    { name: "Nashua", zips: "03060–03064" },
    { name: "Litchfield", zips: "03052" },
    { name: "Pelham", zips: "03076" },
    { name: "Merrimack", zips: "03054" },
    { name: "Hollis", zips: "03049" },
    { name: "Brookline", zips: "03033" },
    { name: "Amherst", zips: "03031" },
    { name: "Milford", zips: "03055" },
    { name: "Derry", zips: "03038" },
    { name: "Londonderry", zips: "03053" },
    { name: "Salem", zips: "03079" },
    { name: "Windham", zips: "03087" },
    { name: "Manchester", zips: "03101–03111" },
    { name: "Tyngsborough", zips: "01879" },
    { name: "Dunstable", zips: "01827" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent southern New Hampshire departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Prepaid overnight labels to our processing center" },
  ],
  internalLinks: [
    { name: "Manchester", route: "/cities/manchester" },
    { name: "Nashua", route: "/cities/nashua" },
    { name: "Derry", route: "/cities/derry" },
    { name: "Londonderry", route: "/cities/londonderry" },
    { name: "Concord", route: "/cities/concord-nh" },
    { name: "Portsmouth", route: "/cities/portsmouth" },
    { name: "Keene", route: "/cities/keene" },
    { name: "Dover", route: "/cities/dover" },
  ],
  fpcOfficeAddress: "One Boston Place, #2600, Boston, MA 02108",
  fpcOfficeNote: "Fast Passport Center serves Hudson remotely via secure courier. We do not have a walk-in office in Hudson — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for southern New Hampshire travelers.",
  fpcOfficeDistance: "Serving all of Hillsborough and Rockingham Counties",
  serviceAreaIntro: "From Hudson's neighborhoods along the Merrimack River to the Derry Road commercial corridor, from the Massachusetts border to the Nashua line — Fast Passport Center serves the entire Hudson community. We regularly help travelers from Nashua, Litchfield, Pelham, and Hollis get their passports fast.",
  nearbyCitiesIntro: "We serve all Hudson neighborhoods and nearby southern New Hampshire cities including Nashua, Litchfield, Pelham, Hollis, Brookline, Amherst, Milford, Derry, Londonderry, Salem, and Windham. If you are in the greater Hudson area, we have you covered.",
  howItWorksIntro: "Most Hudson travelers complete everything online and ship documents overnight. No need to drive to Boston or wait in line at the regional agency.",
  mistakesIntro: "With Manchester-Boston Regional Airport (MHT) just 20 minutes away and Boston Logan an hour south, Hudson travelers can't afford passport delays. Here are the most common mistakes we see.",
  testimonialsIntro: "Hudson and southern New Hampshire travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Hudson? Here are the most common ones we hear from southern New Hampshire travelers.",
  statePageRoute: "/states/new-hampshire",
  statePageName: "New Hampshire",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Bereavement or medical crisis", "Expect to wait all day or return next day"],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Predictable turnaround", "Ideal for upcoming trips", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For travelers with immediate departure needs — as fast as 24 hours for urgent Hudson international flights.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Hudson", description: "Urgent passport processing for Hudson travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal Hudson", description: "Fast passport renewal for Hudson residents with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport Application Hudson", description: "First-time passport application assistance for Hudson residents with step-by-step acceptance clerk guidance." },
    { name: "Lost or Stolen Passport Replacement Hudson", description: "Passport replacement service for Hudson residents with lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport Service Hudson", description: "Passport services for Hudson families with minors under 16, including parental consent documentation." },
    { name: "Passport Name Change Hudson", description: "Passport name change service for Hudson residents after marriage, divorce, or legal name changes." },
  ],
  testimonials: [
    {
      name: "Steven K.",
      location: "Hudson, NH",
      rating: 5,
      text: "My business trip to Toronto was in 3 days and my passport was expired. Fast Passport Center got me a new one in 30 hours. Absolutely saved my trip from Hudson.",
      service: "Emergency Passport",
    },
    {
      name: "Laura P.",
      location: "Hudson, NH",
      rating: 5,
      text: "Needed to renew for a family vacation to Aruba. The process was smooth, they reviewed my documents, and I had my passport in 4 days. Highly recommend for Hudson residents.",
      service: "Passport Renewal",
    },
    {
      name: "Michael H.",
      location: "Nashua, NH",
      rating: 5,
      text: "Lost my passport the week before my European business trip. They walked me through the DS-64 process and got me a replacement in 2 days. Incredible service for the Nashua-Hudson area.",
      service: "Lost Passport",
    },
    {
      name: "Jennifer C.",
      location: "Litchfield, NH",
      rating: 5,
      text: "As a frequent international traveler from Litchfield, I can't afford passport delays. Fast Passport Center has been my go-to for years. Professional and reliable for Hillsborough County.",
      service: "Expedited Renewal",
    },
  ],
  facilities: [
    {
      id: "hudson-1",
      name: "Hudson Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "Derry Rd",
      city: "Hudson",
      state: "NH",
      zip: "03051",
      phone: "(603) 882-6013",
      hours: "Mon–Fri: 9:00 AM – 3:00 PM",
      distance: "0.8 miles from downtown Hudson",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary acceptance facility for Hudson. Limited hours — appointments required. Call ahead to confirm passport acceptance times.",
      icon: "ri-mail-line",
    },
    {
      id: "hudson-2",
      name: "Nashua Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "10 Spring St",
      city: "Nashua",
      state: "NH",
      zip: "03060",
      phone: "(603) 882-4012",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "3.2 miles from Hudson",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Major facility for southern New Hampshire. Popular for Hudson residents. Appointment strongly recommended.",
      icon: "ri-mail-line",
    },
    {
      id: "hudson-3",
      name: "Litchfield Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "2 Sherburne Rd",
      city: "Litchfield",
      state: "NH",
      zip: "03052",
      phone: "(603) 424-2277",
      hours: "Mon–Fri: 9:00 AM – 3:00 PM",
      distance: "4.5 miles from Hudson",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Litchfield and Hudson residents. Limited hours — book ahead.",
      icon: "ri-mail-line",
    },
    {
      id: "hudson-4",
      name: "Pelham Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "6 Main St",
      city: "Pelham",
      state: "NH",
      zip: "03076",
      phone: "(603) 635-7726",
      hours: "Mon–Fri: 9:00 AM – 3:00 PM",
      distance: "5.8 miles from Hudson",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Pelham and southern Hillsborough residents. Photo services available. Book ahead.",
      icon: "ri-mail-line",
    },
    {
      id: "hudson-5",
      name: "Merrimack Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1 Baboosic Lake Rd",
      city: "Merrimack",
      state: "NH",
      zip: "03054",
      phone: "(603) 429-4081",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "7.1 miles from Hudson",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Popular for central Hillsborough residents. Appointment strongly recommended.",
      icon: "ri-mail-line",
    },
    {
      id: "hudson-6",
      name: "Nashua City Clerk",
      type: "City Clerk Passport Acceptance",
      address: "229 Main St",
      city: "Nashua",
      state: "NH",
      zip: "03060",
      phone: "(603) 589-3010",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "3.5 miles from Hudson",
      website: "https://www.nashuanh.gov/",
      websiteLabel: "Nashua City Clerk",
      notes: "Municipal facility with extended hours. Accepts walk-ins but appointments recommended for faster service.",
      icon: "ri-government-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — downtown Boston", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Hudson photo shops often use generic sizes. Passport photos must be exactly 2x2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Hillsborough County acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Hudson applicants show up with incorrect checks and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the Boston regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Hudson families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Hudson travelers often assume standard processing will be fine. It takes 6–13 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Hudson." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Hudson address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Hudson before international travel?", a: "Yes. Fast Passport Center provides emergency passport services in Hudson for travelers with urgent international flights. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24–48 hour turnaround for most southern New Hampshire travelers." },
    { q: "How fast can I renew my passport in Hudson?", a: "Fast Passport Center offers fast passport renewal in Hudson in as little as 24–48 hours through our emergency courier service. For less urgent travel, our 3–5 day expedited option provides the best value." },
    { q: "What if my passport expires before my cruise?", a: "If your passport expires before your cruise, contact Fast Passport Center immediately. We can expedite your passport renewal in Hudson in 24–48 hours so you don't miss your departure." },
    { q: "Can I get a same-day passport appointment near Hudson?", a: "Same-day passport appointments are only available at the Boston Regional Passport Agency for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24–48 hour emergency courier processing is the fastest guaranteed option for Hudson residents." },
    { q: "Can I expedite a child passport in Hudson?", a: "Yes. Fast Passport Center expedites child passports in Hudson for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Hudson with DS-64 form guidance. Our emergency courier service can get your replacement passport in 24–48 hours." },
    { q: "How fast can I get a passport in Hudson?", a: "With Fast Passport Center's emergency courier service, Hudson travelers can receive their passport in as little as 24–48 hours. Our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities, bypassing standard mail delays." },
    { q: "Do I need to visit the Boston Passport Agency?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change." },
    { q: "Where are the closest passport acceptance facilities in Hudson?", a: "Popular options include the Hudson Post Office (03051), Nashua Post Office (03060), Litchfield Post Office (03052), and Nashua City Clerk (03060). All require appointments. We help you find the most convenient location and schedule your visit." },
    { q: "Can I get a same-day passport in Hudson?", a: "Same-day passports are only available at the Boston Regional Passport Agency for documented life-or-death emergencies with proof of travel within 72 hours. For all other urgent travel, Fast Passport Center's 24–48 hour emergency processing is the fastest reliable option." },
    { q: "What if I live in a nearby town like Nashua or Litchfield?", a: "We serve all of southern New Hampshire including Nashua, Litchfield, Pelham, Hollis, Brookline, Amherst, Milford, Derry, and Londonderry. Our overnight shipping labels work from any UPS location, so your location doesn't affect processing speed." },
    { q: "How much does expedited passport service cost in Hudson?", a: "Government fees are fixed: $130 for a passport book (adult) plus a $60 expedite fee. Fast Passport Center's service fees vary by processing speed — emergency 24–48 hour processing, 3–5 day expedited, or standard options. Contact us for a personalized quote based on your timeline." },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Hudson", address: "77 Derry Rd, Hudson, NH 03051", hours: "Mon–Sun: 8AM–10PM", website: "https://www.cvs.com/store-locator/cvs-pharmacy-photo", websiteLabel: "CVS Photo" },
    { name: "Walgreens — Nashua", address: "135 E Hollis St, Nashua, NH 03060", hours: "Mon–Sun: 7AM–11PM", website: "https://www.walgreens.com/storelocator", websiteLabel: "Walgreens Photo" },
    { name: "FedEx Office — Nashua", address: "10 Webster St, Nashua, NH 03064", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM", website: "https://www.fedex.com/en-us/location.html", websiteLabel: "FedEx Office" },
    { name: "UPS Store — Nashua", address: "9 Northwestern Dr, Nashua, NH 03062", hours: "Mon–Fri: 8AM–7PM, Sat: 9AM–5PM", website: "https://www.theupsstore.com/tools/find-a-store", websiteLabel: "UPS Store" },
    { name: "Walmart — Hudson", address: "254 Lowells Rd, Hudson, NH 03051", hours: "Mon–Sun: 6AM–11PM", website: "https://www.walmart.com/store/finder", websiteLabel: "Walmart Photo" },
    { name: "Rite Aid — Nashua", address: "100 E Hollis St, Nashua, NH 03060", hours: "Mon–Sun: 8AM–10PM", website: "https://www.riteaid.com/locations/search", websiteLabel: "Rite Aid Photo" },
    { name: "Costco — Nashua", address: "1000 E Hollis St, Nashua, NH 03060", hours: "Mon–Fri: 10AM–8:30PM, Sat–Sun: 9:30AM–6PM", website: "https://www.costco.com/warehouse-locations", websiteLabel: "Costco Photo" },
  ],
  dmvLocations: [
    { name: "DMV — Nashua", address: "110 Broad St, Nashua, NH 03064", hours: "Mon–Fri: 8AM–5PM", note: "REAL ID and driver's license renewals. Appointment required.", featured: true },
    { name: "DMV — Manchester", address: "23 Hazard Ave, Manchester, NH 03109", hours: "Mon–Fri: 8AM–5PM", note: "Passport-ready photo services available. Online appointment booking.", featured: false },
    { name: "DMV — Milford", address: "91 Dudley Rd, Milford, NH 03055", hours: "Mon–Fri: 8AM–5PM", note: "REAL ID processing. Walk-ins limited — book online first.", featured: false },
    { name: "DMV — Concord", address: "23 Hazen Dr, Concord, NH 03301", hours: "Mon–Fri: 8AM–5PM", note: "Full-service center for central New Hampshire residents.", featured: true },
  ],
  airports: [
    { code: "MHT", name: "Manchester-Boston Regional Airport", distance: "20 miles from Hudson", address: "1 Airport Rd, Manchester, NH 03103", note: "Closest major airport for Hudson travelers. International flights to Canada and Europe. Major domestic hub.", flightUrl: "https://www.flymanchester.com/", flightLabel: "MHT Flight Info", featured: true },
    { code: "BOS", name: "Boston Logan International Airport", distance: "45 miles from Hudson", address: "1 Harborside Dr, Boston, MA 02128", note: "Major international hub for long-haul flights to Europe, Asia, and South America. Accessible via I-93.", flightUrl: "https://www.massport.com/logan-airport", flightLabel: "Logan Airport", featured: false },
    { code: "PSM", name: "Portsmouth International Airport", distance: "42 miles from Hudson", address: "36 New Hampshire Ave, Portsmouth, NH 03801", note: "Regional airport with some international flights. Convenient for Seacoast New Hampshire travelers.", flightUrl: "https://www.flyportsmouth.com/", flightLabel: "Portsmouth Airport", featured: false },
  ],
};